import { render } from "./product-swatches.vue?vue&type=template&id=0e53a3c8"
import script from "./product-swatches.vue?vue&type=script&lang=js"
export * from "./product-swatches.vue?vue&type=script&lang=js"

import "./product-swatches.vue?vue&type=style&index=0&id=0e53a3c8&lang=scss"

import exportComponent from "/buddy/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__